// FIXME: This should be exported from the ra-core package
type CanAccessParams<
    RecordType extends Record<string, any> = Record<string, any>,
> = {
    action: string;
    resource: string;
    record?: RecordType;
};

export const canAccess = <
    RecordType extends Record<string, any> = Record<string, any>,
>(
    role: string,
    params: CanAccessParams<RecordType>
) => {
    if (role === 'admin') {
        return true;
    }

    // Non-admin role checks
    if (role === 'user') {
        // Deny access to admin-only resources
        const restrictedResources = ['sales', 'rate-manager', 'admin-panel'];

        if (restrictedResources.includes(params.resource)) {
            return false;
        }

        // Allow access to other resources/actions by default for non-admins if needed
        // For example, they might still need access to settings or their own profile
        // Or deny all other access implicitly by returning false here if non-admins should ONLY access specific things.
        // Current logic allows access to non-restricted resources.
    }

    // Default grant access if no specific rules deny it (adjust if default should be deny)
    return true;
};
